<script setup lang="ts">
import { preloadSettlements } from "~/utils/preload/settlements";
import { readLoggedAsAdmin } from "~/utils/adminCookiesCRUD";

const { projectId, isUser } = useUser();

const menuOpen = ref(false);
const screenMd = ref(window.innerWidth >= 1280);
const isLoggedAsAdmin = computed(() => readLoggedAsAdmin());

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

const updateScreenSize = () => {
  screenMd.value = window.innerWidth >= 1280;
  if (screenMd.value) {
    menuOpen.value = false;
  }
};

preloadSettlements();

onMounted(() => {
  updateScreenSize();
  window.addEventListener("resize", updateScreenSize);
});
onUnmounted(() => {
  window.removeEventListener("resize", updateScreenSize);
});
</script>

<template>
  <div class="flex min-h-dvh w-full flex-col bg-primary xl:flex-row">
    <Transition name="fade">
      <PanelDesktopMenu
        v-if="menuOpen || screenMd"
        data-testid="panel-desktop-menu"
        class="absolute left-0 top-0 z-50 h-full w-64 bg-surface-100 lg:static xl:static
          xl:block"
        @update-menu-state="toggleMenu"
      />
    </Transition>
    <!-- <div
      class="mx-2 mb-2 flex w-full flex-col rounded-b-lg bg-surface-100 px-8 pb-8"
    > -->
    <div class="flex items-center justify-between">
      <router-link to="/">
        <img
          src="/app-logo.png"
          class="h-22 ml-3 block w-36 object-contain contrast-125 filter xl:hidden"
        />
      </router-link>
      <div class="flex items-center">
        <PanelNotificationsIcon class="ml-10 xl:hidden" />
        <button
          data-testid="panel-desktop-menu"
          class="m-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-200 p-3
            shadow-lg xl:hidden"
          @click="toggleMenu"
        >
          ☰
        </button>
      </div>
    </div>
    <div
      class="m-0 flex w-full flex-grow flex-col rounded-t-lg bg-surface-100 p-4 xl:m-2
        xl:rounded-lg xl:p-8"
    >
      <PanelTopBar />

      <PanelContent v-if="projectId" class="flex-grow pt-4 md:pt-8">
        <PrimeMessage v-if="isLoggedAsAdmin" severity="error" class="mb-4">
          <div class="flex items-center gap-2">
            <i class="pi pi-shield text-lg"></i>
            <span
              >Jesteś zalogowany w trybie administratora na konto
              użytkownika</span
            >
          </div>
        </PrimeMessage>
        <slot> </slot
      ></PanelContent>
      <PrimeMessage v-else-if="isUser" severity="error" class="mt-2"
        >Brak projektu</PrimeMessage
      >
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
